// @ts-nocheck

import { type StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { type BoomState } from '../../reducers/boom';

const emptyObj = {};

export const selectBoomState: Selector<BoomState> = (state: StateType) => state.boom ?? emptyObj;
